export const TUTORIAL_STEPS = [
  {
    id: 'behavioral-answers',
    title: 'Your Behavioral Answers',
    description:
      'Keep track of all your behavioral interview answers in one place. Search through your answers and edit them anytime.',
    placement: 'right',
    image: '/maincar.png',
  },
  {
    id: 'add-question',
    title: 'Add Questions & Answers',
    description:
      'Click here to add new behavioral questions and your prepared answers. Build your response bank over time!',
    placement: 'right',
    image: '/thinkingcar.png',
  },
  {
    id: 'mock-interview',
    title: 'Mock Interview',
    description:
      'Practice your behavioral answers with our AI interviewer! Get real-time feedback and improve your responses.',
    placement: 'left',
    image: '/writingcar.png',
  },
];
